import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';

import { ToastComponent } from '../shared/toast/toast.component';
import { AuthService } from '../services/auth.service';
import { FileService } from '../services/file.service';
import { ee } from '../shared/constants';
import { removeTooltipElement, saveFile, filterDatesInArrayByDays } from '../shared/functions';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-upload',
  templateUrl: './pdf.component.html',
  styleUrls: ['./pdf.component.scss'],
  standalone: false
})
export class PdfComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  private http = inject(HttpClient);
  private fileService = inject(FileService);
  toast = inject(ToastComponent);


  isLoading = { uploaded: true, converted: true };
  selectedFiles: FileList;
  converted: any[] = [];
  uploaded: any[] = [];
  convertedFiltered: any[] = [];
  uploadedFiltered: any[] = [];
  progressInfos = [];
  uploadError = false;
  daysBack = 15;
  currentContent = 'pdf';
  menuItems = [
    { name: 'PDF', link: 'pdf', icon: 'file-pdf-o' }
  ];

  ngOnInit(): void {
    this.getAllFiles();
    ee.on('changeContent', (data: string) => this.currentContent = data);
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    removeTooltipElement();
  }

  getAllFiles(): void {
    this.getFiles('uploaded');
    this.getFiles('converted');
  }

  getFiles(dir: 'converted' | 'uploaded'): void {
    this.isLoading[dir] = true;
    this.fileService.getAll(dir)
      .pipe(finalize(() => this.isLoading[dir] = false))
      .subscribe({
        next: res => {
          this[dir] = res;
          this[`${dir}Filtered`] = filterDatesInArrayByDays(res, 'date', this.daysBack);
        },
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

  selectFiles(event): void {
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
    this.uploadFiles(this.selectedFiles);
  }

  uploadFiles(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      this.upload(i, files[i]);
    }
  }

  upload(idx: number, file): Subscription {
    this.progressInfos[idx] = { value: 0, fileName: file.name };
    this.uploadError = false;
    return this.fileService.upload(file, 'upload')
      .subscribe({
        next: event => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].value = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            this.toast.setMessage('Files uploaded successfully!', 'success');
            this.getFiles('uploaded');
          }
        },
        error: err => {
          this.uploadError = true;
          this.toast.setMessage(err.error.message, 'danger', 10000);
        }
      });
  }

  deleteFile(file: string, dir: 'converted' | 'uploaded'): void {
    if (window.confirm('Are you sure you want to permanently delete this file?')) {
      this.fileService.delete(file, dir)
        .subscribe({
          next: res => {
            this.toast.setMessage('File deleted successfully!', 'success');
            this.getFiles(dir);
          },
          error: err => this.toast.setMessage(err.error.message, 'danger')
        });
    }
  }

  saveAs(file: any): Subscription {
    this.toast.setMessage('Download started, please wait...', 'info');
    return this.http.get(file.url, { responseType: 'blob' })
      .subscribe({
        next: res => saveFile(res, file.name),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
        complete: () => this.toast.setMessage('Download finished', 'success')
      });
  }

}
